import { Toast } from 'bootstrap';
import Rellax from 'rellax';

const toasts = new Map();

document.addEventListener('DOMContentLoaded', () => {

  // --- Statistiques ---
  const section = document.querySelector('#statistiques');
  if (section) {
    const items = section.querySelectorAll('ul li');
    const delay = 1250 / items.length;
    const activate = () => {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      items.forEach((li, i) => {
        reduced ? li.classList.add('active') : setTimeout(() => li.classList.add('active'), i * delay);
      });
    };
    new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) { activate(); obs.unobserve(section); }
      });
    }, { threshold: 0.3 }).observe(section);
  }

  // --- Parallax ---
  const parallaxElements = document.querySelectorAll("[data-parallax]");
  if(parallaxElements.length > 0){
    parallaxElements.forEach(p => {
      const container = p.parentElement;
      new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            p.classList.add('is-visible');
            if (!p.classList.contains("rellax-loaded")) {
              new Rellax(p, { center: true, wrapper: null, round: true, vertical: true, horizontal: false });
              p.classList.add("rellax-loaded");
            }
          } else {
            p.classList.remove('is-visible');
          }
        });
      }, { threshold: 0, rootMargin: '300px 0px 300px 0px' }).observe(container);
    });
  }

  document.querySelectorAll('.toast').forEach(toastEl => {
    toasts.set(toastEl.id, new Toast(toastEl, { animation: true, autohide: true, delay: 5000 }));
  });

  // Bouton scroll to top
  const btn = document.getElementById("scrollToTop");
  const mainContent = document.getElementById("main-content");
  const nav = document.querySelector("nav");

  btn.addEventListener("click", function(){
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  document.addEventListener("scroll", () => {
    const top = mainContent.getBoundingClientRect().top;
    if (top <= 500) {
      btn.classList.add("discovered");
      nav.classList.add("reduce");
    } else {
      btn.classList.remove("discovered");
      nav.classList.remove("reduce");
    }
  });
});

window.showToast = function(id, message, status = "success") {
  const toast = toasts.get(id);
  if (!toast) return;
  const el = toast._element;
  el.classList.toggle('bg-success', status === 'success');
  el.classList.toggle('bg-danger', status !== 'success');
  el.querySelector('.toast-body .toast-message').textContent = message;
  toast.show();
};